<script lang="ts" setup></script>

<template>
  <UContainer
    class="flex flex-col justify-center items-center pt-10 md:pt-20 pb-10 gap-5"
  >
    <slot />
  </UContainer>
</template>

<style></style>
